import { render } from "./SearchPerson.vue?vue&type=template&id=1c4bc2de&scoped=true"
import script from "./SearchPerson.vue?vue&type=script&lang=js"
export * from "./SearchPerson.vue?vue&type=script&lang=js"

import "./SearchPerson.vue?vue&type=style&index=0&id=1c4bc2de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4bc2de"]])

export default __exports__